export const AdminMultimediaGridDefaultTemplateColumns =
  'sm:grid-cols-2 md:grid-cols-5 lg:grid-cols-7 xl:grid-cols-10 2xl:grid-cols-12';
